import showdown from "showdown";

export function formatTextLabel(value) {
  if (value) {
    const text = value;
    return text.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
  }
  return "";
}

export function formatPropertyLabel(value) {
  if (value) {
    const text = value;
    return text.replace(/_/g, " ").trim();
  }
  return "";
}

export function formatNewsCategory(value) {
  if (value) {
    const text = value;
    return text.replace(/-/g, " ").trim();
  }
  return "";
}

export function truncateText(value, length) {
  if (value.length > length) {
    return value.substring(0, length) + "...";
  }
  return value;
}

export function convertMarkdown(value) {
  if (value) {
    const text = value;
    const converter = new showdown.Converter();
    return converter.makeHtml(text);
  }
  return "";
}

export function formatUrl(value) {
  if (value) {
    const name = value;
    return name
      .replace(/ /g, "-")
      .replaceAll("'", "")
      .toLowerCase();
  }
  return "";
}

export function formatId(value) {
  if (value) {
    const name = value;
    return name
      .replace(/ /g, "-")
      .replaceAll("'", "")
      .toLowerCase();
  }
  return "";
}

export function hasValue(value) {
  if (value) {
    return value;
  }
  return "Not Available";
}
